export const addZeroToNumber = (num: number): string => {
  if (num === 0) {
    return '0';
  }

  return num < 10 ? `0${num}` : num + '';
};
